import { get, post } from '../request'

export const createWebSearchItem = (params) => post('api/app-item-web-searches', params)
export const getWebSearchReportByProject = (filter = {}) =>
  get(`api/app-item-web-searches/report/web-search-result`, { filter })
export const getAiBillingReport = (filter = {}) => get(`api/app-item-web-searches/report/billing`, { filter })
